import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Router } from '@gatsbyjs/reach-router';

import metadata from './metadata.json';
import SEO from '@common/components/SEO/SEO';
import { Payments } from '@views';
import PaymentConfirmation from '@views/Payments/PaymentConfirmation';
import { Layout } from '@components';
import { FinancingConsentModal } from '@views/Payments/FinancingConsentModal';
import { OAuthLoader } from '@views/Payments/OAuthLoader';

const Orders = ({ orderId, location, isWebdevMobile, basepath }) => {
  const { prefixLanguage } = useSelector(({ appState }) => appState);
  const language = prefixLanguage || 'en';
  return (
    <Layout
      theme="dark"
      location={location}
      backgroundColor="white"
      invertibleLinkTheme={!isWebdevMobile}
      hideReserve
      hideFooter
    >
      <SEO
        title={metadata.title[language]}
        description={metadata.description[language]}
        location={location}
      />
      <Router
        primary={false}
        location={location}
        basepath={`${basepath}orders`}
      >
        <Payments
          path="/:orderId/payments"
          orderId={orderId}
          basepath={basepath}
        />
        <PaymentConfirmation
          path="/:orderId/payments/confirmation"
          orderId={orderId}
          location={location}
          basepath={basepath}
        />
        <FinancingConsentModal
          path="/:orderId/financing/consent"
          orderId={orderId}
          basepath={basepath}
        />
        <OAuthLoader path="/oauth" basepath={basepath} />
        <Redirect noThrow={true} from="*" to="/portal/designs" />
      </Router>
    </Layout>
  );
};

export default Orders;
